<app-appels-card [idBdc]="idBdc"></app-appels-card>